import React from 'react';

import { isDateTypeSupported } from '../useful';
import NativeDateInput from './NativeDateInput';
import SafariDateInput from './SafariDateInput';

const DateInput = (props) => {
    return isDateTypeSupported() ? <NativeDateInput {...props} /> : <SafariDateInput {...props} />;
}

export default DateInput;